<div class="row pb-4">
    <h2 class="col-12">Event Types</h2>
    <div class="row col-12">
        <div class="col-md-4 col-12"  *ngFor="let event of EventList">
            <label class="container-label">
                {{event.type}}&nbsp;&nbsp;
                <input type="checkbox" value={{event.type}} (change)="onCheckChange($event)" [(ngModel)]="event.isChecked">
                <span class="checkmark" style="background-color:{{event.backgroundColor}};"></span>
            </label>
        </div>
    </div>
</div>
<div>
    <full-calendar deepChangeDetection="true" [options]="calendarOptions"></full-calendar>
</div>
